import { useState } from "react";
import { X, MessageCircle } from "lucide-react";
import { KESH_HELP } from "./constants";

const HIDE = "gi_kesh_tip_hidden";
const ask = (message) => window.dispatchEvent(new CustomEvent("kesh-ask", { detail: { message } }));

export default function KeshTip({ step, help: given, testid = "studio" }) {
  const key = testid === "studio" ? HIDE : `${HIDE}_${testid.split("-")[0]}`;
  const [hidden, setHidden] = useState(() => localStorage.getItem(key) === "1");
  const help = given || KESH_HELP[step];
  const toggle = (v) => { setHidden(v); localStorage.setItem(key, v ? "1" : "0"); };
  if (!help) return null;
  if (hidden) {
    return (
      <div className="mb-5 flex justify-end">
        <button data-testid={`${testid}-kesh-show`} onClick={() => toggle(false)} className="gi-btn gi-btn-sm text-kesh-text hover:bg-kesh-soft">
          <MessageCircle className="w-4 h-4" aria-hidden="true" /> Tips from Kesh
        </button>
      </div>
    );
  }
  return (
    <aside data-testid={`${testid}-kesh-tip`} aria-label="Help from Kesh" className="mb-5 sm:mb-6 rounded-2xl border border-kesh/20 bg-kesh-soft/60 p-3 sm:p-4 flex gap-2.5 sm:gap-3 af-fade-up">
      <span className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-kesh text-onbrand flex items-center justify-center text-xs sm:text-sm font-bold shrink-0" aria-hidden="true">K</span>
      <div className="min-w-0 flex-1">
        <p className="text-sm sm:text-[15px] text-ink leading-relaxed" data-testid={`${testid}-kesh-tip-text`}>
          <span className="font-semibold text-kesh-text">Kesh tip · </span>{help.tip}
        </p>
        <div className="mt-2.5 flex gap-2 overflow-x-auto scroll-row -mr-3 pr-3 sm:mr-0 sm:pr-0 sm:flex-wrap sm:overflow-visible">
          {help.ask.map((q, i) => (
            <button key={q} data-testid={`${testid}-kesh-ask-${i}`} onClick={() => ask(q)}
              className="px-3 py-1.5 min-h-[36px] rounded-full border border-kesh/30 bg-surface text-sm text-ink text-left whitespace-nowrap shrink-0 sm:whitespace-normal sm:shrink hover:bg-kesh-soft hover:border-kesh/50 transition-colors">
              {q}
            </button>
          ))}
        </div>
      </div>
      <button data-testid={`${testid}-kesh-tip-hide`} onClick={() => toggle(true)} aria-label="Hide Kesh tips"
        className="w-9 h-9 -mt-1 -mr-1 rounded-lg flex items-center justify-center text-body hover:bg-surface shrink-0 transition-colors">
        <X className="w-4 h-4" />
      </button>
    </aside>
  );
}
